import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../../components/MainContentLayout'
import { PlaylistsRouter, TracksRouter } from '../../../utils/routes/MusicRoutes'
import { Button, message } from 'antd'
import { listenerMiddleware, useAppDispatch } from '../../../utils/redux/store'
import { attemptUpdatePlaylistsCounters } from '../../../utils/redux/playlistsSlice'
import { useAttemptListener } from 'dev-masters-react-kit'

const menu: ItemType<MenuItemType>[] = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'New',
    key: 'new',
  },
]

export default function PlaylistsLayout() {
  const dispatch = useAppDispatch()

  const handleUpdateCounters = () => {
    dispatch(attemptUpdatePlaylistsCounters())
  }

  useAttemptListener({
    listenerMiddleware: listenerMiddleware,
    attempt: attemptUpdatePlaylistsCounters,
    onFulfilled: () => {
      message.success('Playlist counters have been updated successfully!')
    },
    onRejected: () => {
      message.error('Failed to update playlist counters.')
    }
  })

  return (
    <MainContentLayout
      navigationHeader={{
        headerMenu: menu,
        navigationPrefix: '/music/playlists/',
      }}
      header={<Button size='small' type='default' onClick={handleUpdateCounters}>Update counters</Button>}
    >
      <PlaylistsRouter />
    </MainContentLayout>
  )
}
